import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CASE } from "@/constants/testIds";

export default function CaseCard({ c, compact = false }) {
  return (
    <Link
      to={`/casi-studio/${c.slug}`}
      data-testid={CASE.card}
      className="block group h-full flex flex-col rounded-xl transition-all duration-300 hover:-translate-y-1"
      style={{
        textDecoration: "none",
        padding: compact ? "24px" : "32px",
        background: "var(--lovac-bg-2)",
        border: "0.5px solid var(--lovac-border)",
        boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
      }}
    >
      <div className="flex items-start justify-between mb-7">
        <div className="h-12 w-12 rounded-lg bg-lovac flex items-center justify-center text-sm font-medium text-lovac-dark border-lovac">
          {c.logo_iniziale}
        </div>
        <ArrowUpRight size={20} className="text-lovac-muted group-hover:text-lovac-accent transition-colors" />
      </div>

      <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
        <span className="text-[11px] text-lovac-muted uppercase tracking-wider">
          {c.settore} · <span className="text-lovac-dark">{c.tipo_figura}</span>
        </span>
        <span
          className="font-mono text-xs font-medium rounded-full px-3 py-1.5"
          style={{
            background: "rgba(0, 196, 140, 0.12)",
            color: "var(--lovac-accent-hover)",
          }}
        >
          {c.time_to_hire}
        </span>
      </div>

      <h3 className={`font-display ${compact ? "text-lg" : "text-2xl"} text-lovac-dark leading-tight`}>
        {c.ruolo_cercato}
      </h3>
      <p className="text-sm text-lovac-muted mt-2">{c.nome_azienda}</p>

      {!compact && (
        <blockquote className="text-base text-lovac-dark mt-8 leading-[1.65] border-l-2 border-lovac-accent pl-5 italic flex-1">
          "{c.citazione_principale}"
        </blockquote>
      )}

      <div className={`${compact ? "mt-5 pt-4" : "mt-8 pt-6"} border-t border-lovac flex items-center justify-between gap-4`}>
        <span className="text-xs text-lovac-muted">{c.nome_cliente}, {c.ruolo_cliente}</span>
        <span className="text-sm text-lovac-dark group-hover:text-lovac-accent transition-colors whitespace-nowrap">
          Leggi →
        </span>
      </div>
    </Link>
  );
}
